import React, { useState, useEffect, createRef } from 'react';
import styled from 'styled-components';
import { Icon } from '@zebra-fed/zds-react-desktop';
import TextField from '@material-ui/core/TextField'; 
import '@zebra-fed/icons/General/index.css';
import {useTranslation} from "react-i18next";
import SearchIcon from '@material-ui/icons/Search';
import { Button, RadioButtonGroup, Item } from "@zebra-fed/zds-react-desktop";
import RefreshIcon from '@material-ui/icons/Refresh';

const ToolbarWrapper = styled.div`
    display: flex;
    justify-content: end;
    align-items: center;
    position: relative;
    z-index: 999;
    margin-right: auto;
    // top: -60px;
    display: flex;
    flex-direction: row;
    align-items: end;
    width: fit-content;
    // right: 0;
    // left: auto;
    padding: 5px;
    border-radius: 4px;
    margin-right: 0;
    margin-left: auto;
    @media screen and (max-width: 750px) {
        // right: auto;
        padding-left: 0;
        margin-top: 10px;
        width: 100%;
        justify-content: space-between;
    }
`

const RefreshIconStyled = styled(RefreshIcon)`
    fill: #0073E6 !important;
    margin-right: 20px;
    border-style:solid;
    border-radius: 4px;
    border-width: thin;
    padding:4px;
    border-color: #0073E6;
    &:hover {
        cursor: pointer;
    }
`;


const SearchBoxNComp = styled.div`
    background: white;
    padding: 10px;
    border: 1px solid #bdbdbd;
    position: absolute;
    top: 67px;
    z-index: 999;
    width: max-content;
`;

export default function DevicesToolbar(props) {
    const { multiSearchOpts=[],onRefreshClick } = props;
    const [searchVal, setSearchVal] = useState('');
    const [isError, setIsError] = useState(false)
    const { t } = useTranslation();
    const [openSearchBox,setOpenSearchBox] = useState(false)
    const [searchOptVal, setSearchOptVal] = useState('')
    const radioRef = createRef();
    const [searchInputError, setSearchInputError] = useState("")
    const [searchOptError, setSearchOptError] = useState("")

    useEffect(() => {
        setSearchVal(props.searchText)
        if(props.searchText == ""){
            setSearchOptVal("");
        }
    }, [props.searchText]); // eslint-disable-line react-hooks/exhaustive-deps

    function searchTheVal () {
        let optLength = radioRef.current.getValues().length;
        if (!searchVal) {
            setSearchInputError('Enter a value to search')
        }
        if (multiSearchOpts.length > 0 && optLength === 0) {
            setSearchOptError('Choose a type')
        }
        else {
            props.onSearch(searchVal, searchOptVal);
            setOpenSearchBox(false);
        }
    }

    function onChangeOptItem(e) {
        setSearchOptError("");
        setSearchOptVal(e.target.value);
    }

    function onChangeSearchBox(e) {
        let value = e.target.value;
        // let regexVal = value.replace(/[^a-zA-Z0-9:._,#$[\]\\]/gi, '');
        // let regexVal = value.replace(/[^-?a-zA-Z0-9_:;+=<>?'"!@%^&*(){}|\//\s]/gi, '');
        // console.log(regexVal,'regexVal aps')
        // setSearchVal(e.target.value.trim());
        setSearchVal(value);
        setSearchInputError("")
        if (e.target.value === "") {
            props.onClear(searchVal);
        }
    }

    return (
        <ToolbarWrapper>            
            <RefreshIconStyled onClick={onRefreshClick} />
        <TextField
           error={isError}
           helperText={isError ? t('macNFriendlyNamTextFielde') : ""} //"Please enter a valid email id to search."
           style={{ }}
           placeholder={t('searchPlaceHolder')}
           value={searchVal}
           onFocus={()=>setOpenSearchBox(true)}
           onChange={(e) => {
            onChangeSearchBox(e)
           }}
           onKeyDownCapture={multiSearchOpts.length === 0 ? (e) => {
               console.log(e,'e for kaycode')
               if (e.keyCode === 13) {
                   if(e.target.value.trim() === "")
                       setIsError(true)

                   props.onSearch(searchVal);
               }
           } : null}
           InputProps= {{
               startAdornment: 
                   <Icon 
                       category={'general'}
                       name={'search'}
                       size={15}
                       style={{cursor: 'pointer', padding: '0 8px 4px 0'}}
                       color={'#bdbdbd'}
                   />,
               endAdornment:
                   <Icon 
                       category={'navigation'}
                       name={'close'}
                       size={15}
                       style={{cursor: 'pointer', paddingRight: '4px', 
                       visibility: searchVal === '' ? 'hidden' : 'visible'
                    }}
                    
                       color={'#bdbdbd'}
                       onClick={() => {
                        if ( searchVal ) {
                            setSearchVal('');
                            props.onClear(searchVal);
                        }
                       }}
                   />,
           }}
        />
        {
           openSearchBox && multiSearchOpts.length > 0 &&
           
        <SearchBoxNComp>           
        {searchInputError && <p style={{color: 'red', margin: '0'}}>{searchInputError }</p>}
       <p>{t('matchResultIn')}:</p>
       <RadioButtonGroup
        align="left"
        ref={radioRef}
        onChange={onChangeOptItem}>
            {multiSearchOpts.map((opts,idx) => <Item key={idx}
            defaultChecked={opts.value === searchOptVal}
        value={opts.value}>{opts.name}</Item> )}
        </RadioButtonGroup>
       {searchOptError && <p style={{color: 'red', margin: '0'}}>{searchOptError }</p>}

        <div>
            <Button
            type="primary"
            dense={true}
            style={{ margin: '10px',backgroundColor: '#757575' }}
            onClick={()=>setOpenSearchBox(!openSearchBox)}
            >{t('cancel')}</Button>
            <Button
            type="primary"
            dense={true}
            style={{ margin: '10px' }}
            onClick={()=>searchTheVal()}
            disabled={ searchVal && searchOptVal ? false : true}
                >{t('search')}</Button>
        </div>
        </SearchBoxNComp>
         }
        </ToolbarWrapper>
    )
}